import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'terms' | 'privacy' | null;
function Modal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  const title = type === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad';
  const termsContent = <div className="space-y-6 text-charcoal-light font-light text-sm leading-relaxed" data-id="element-25">
      <p data-id="element-26">
        <strong className="font-medium text-navy" data-id="element-27">Última actualización:</strong>{' '}
        Mayo 2025
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-28">
        1. Aceptación de los Términos
      </h3>
      <p data-id="element-29">
        Al acceder y utilizar este sitio web y adquirir el producto digital
        "Protocolo de Influencia Visual", usted acepta cumplir con estos
        términos y condiciones en su totalidad. Si no está de acuerdo con alguno
        de estos términos, le recomendamos no utilizar este sitio.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-30">2. Producto Digital</h3>
      <p data-id="element-31">
        El "Protocolo de Influencia Visual" es un producto digital descargable
        que incluye guías en formato PDF y materiales complementarios. Una vez
        completada la compra, recibirá acceso inmediato al contenido.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-32">3. Uso del Producto</h3>
      <p data-id="element-33">
        El contenido adquirido es para uso personal y no comercial. Queda
        estrictamente prohibida la reproducción, distribución, modificación o
        reventa del material sin autorización expresa por escrito.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-34">4. Política de Reembolso</h3>
      <p data-id="element-35">
        Debido a la naturaleza digital del producto y su entrega inmediata, no
        se ofrecen reembolsos una vez completada la descarga. Le recomendamos
        revisar toda la información disponible antes de realizar su compra.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-36">5. Propiedad Intelectual</h3>
      <p data-id="element-37">
        Todo el contenido, diseño, textos, gráficos y materiales incluidos en
        este sitio web y en el producto digital están protegidos por derechos de
        autor y son propiedad exclusiva del creador.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-38">
        6. Limitación de Responsabilidad
      </h3>
      <p data-id="element-39">
        Los resultados pueden variar según la dedicación y aplicación
        individual. No garantizamos resultados específicos derivados del uso de
        nuestro material educativo.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-40">7. Modificaciones</h3>
      <p data-id="element-41">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en este sitio.
      </p>
    </div>;
  const privacyContent = <div className="space-y-6 text-charcoal-light font-light text-sm leading-relaxed" data-id="element-42">
      <p data-id="element-43">
        <strong className="font-medium text-navy" data-id="element-44">Última actualización:</strong>{' '}
        Mayo 2025
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-45">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-46">
        Al realizar una compra, recopilamos únicamente la información necesaria
        para procesar su transacción, como nombre y correo electrónico. No
        almacenamos datos de pago; estos son procesados de forma segura por
        nuestro proveedor de pagos.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-47">2. Uso de la Información</h3>
      <p data-id="element-48">
        La información recopilada se utiliza exclusivamente para: procesar y
        entregar su compra, enviar el producto digital adquirido, y comunicarnos
        con usted en caso de ser necesario respecto a su pedido.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-49">3. Protección de Datos</h3>
      <p data-id="element-50">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-51">4. Compartir Información</h3>
      <p data-id="element-52">
        No vendemos, intercambiamos ni transferimos su información personal a
        terceros. La única excepción son los proveedores de servicios de
        confianza que nos asisten en la operación del sitio web y el
        procesamiento de pagos.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-53">5. Cookies</h3>
      <p data-id="element-54">
        Este sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Puede configurar su navegador para rechazar cookies, aunque
        esto podría afectar algunas funcionalidades del sitio.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-55">6. Sus Derechos</h3>
      <p data-id="element-56">
        Usted tiene derecho a acceder, rectificar o solicitar la eliminación de
        sus datos personales en cualquier momento.
      </p>

      <h3 className="font-serif text-lg text-navy" data-id="element-57">
        7. Cambios en esta Política
      </h3>
      <p data-id="element-58">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Cualquier cambio será publicado en esta página.
      </p>
    </div>;
  return <AnimatePresence data-id="element-59">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-navy/80 backdrop-blur-sm" onClick={onClose} data-id="element-60">
        <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="bg-cream w-full max-w-2xl max-h-[80vh] rounded-sm shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-61">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gold/20" data-id="element-62">
            <h2 className="font-serif text-2xl text-navy" data-id="element-63">{title}</h2>
            <button onClick={onClose} className="p-2 hover:bg-cream-dark rounded-full transition-colors" aria-label="Cerrar" data-id="element-64">
              <XIcon className="w-5 h-5 text-charcoal" data-id="element-65" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 md:p-8 overflow-y-auto max-h-[calc(80vh-80px)]" data-id="element-66">
            {type === 'terms' ? termsContent : privacyContent}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-navy border-t border-white/5 py-12 text-center" data-id="element-67">
        <div className="max-w-4xl mx-auto px-6" data-id="element-68">
          <h4 className="font-serif text-xl text-gold-light mb-4" data-id="element-69">
            Protocolo de Influencia Visual
          </h4>
          <p className="text-cream-dark/40 text-sm font-light mb-8" data-id="element-70">
            Diseñado exclusivamente para la mujer profesional moderna.
          </p>
          <div className="text-cream-dark/30 text-xs flex flex-col md:flex-row justify-center items-center space-y-2 md:space-y-0 md:space-x-6" data-id="element-71">
            <span data-id="element-72">
              &copy; {new Date().getFullYear()} Todos los derechos reservados.
            </span>
            <button onClick={() => setActiveModal('terms')} className="hover:text-gold transition-colors cursor-pointer" data-id="element-73">
              Términos y Condiciones
            </button>
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gold transition-colors cursor-pointer" data-id="element-74">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <Modal type={activeModal} onClose={() => setActiveModal(null)} data-id="element-75" />
    </>;
}